// extracted by mini-css-extract-plugin
module.exports = {"selectAircraft":"selectAircraft--2mRMe"};